import { ENEMIES } from '../../data/enemies';
import { createCircle, type Circle } from '../collision';

/**
 * EN-23 Gaviota (GDD §8.3, issue #106): a flock of three in a V that moves like the gallinazo (EN-01): the
 * leader follows stepGallinazo and the wingmen keep a fixed offset, so the V moves rigid and in phase. The
 * leader flies in front (on the left, they fly left) and the wingmen `spacingX` behind, `spacingY` above and
 * below (`EnemyDef.params`). Each seagull is a harmful circle of the EN-01 radius.
 */
export const EN23 = ENEMIES['EN-23'];

export interface FlockParams {
  spacingX?: number;
  spacingY?: number;
}

/** Offsets of the three seagulls from the leader: the leader, the upper wingman and the lower one. */
export function flockOffsets(params: FlockParams = {}): { dx: number; dy: number }[] {
  const dx = params.spacingX ?? EN23.spacingX;
  const dy = params.spacingY ?? EN23.spacingY;
  return [
    { dx: 0, dy: 0 },
    { dx, dy },
    { dx, dy: -dy },
  ];
}

/** Where the three seagulls are when the leader is at (x, y). */
export const flockMembers = (x: number, y: number, params: FlockParams = {}): { x: number; y: number }[] =>
  flockOffsets(params).map(({ dx, dy }) => ({ x: x + dx, y: y + dy }));

/** The hitboxes of the flock: one circle per seagull. */
export const flockCircles = (x: number, y: number, params: FlockParams = {}): Circle[] =>
  flockMembers(x, y, params).map((member) => createCircle(member.x, member.y, EN23.hitboxRadius));
